import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
// @ts-ignore
import { useAuth } from "../../../../../context/LoginContext.jsx";
//@ts-ignore
import { LanguageContext } from "../../../../../context/LanguageContext.jsx";
//@ts-ignore
import axios from "../../../../../lib/axios.js";
//@ts-ignore
import { dataList } from "../../../AdmMain";
import { DeleteFun } from "../../../../Atomic/exFunc";
import CommonControl from "../../../../Atomic/organism/CommonControl";
import Page from "../../../../Atomic/template/PageTable";
// @ts-ignore
import Select from "../../../../Atomic/molecules/Select";
import Radio from "../../../../Atomic/atoms/Radio";
import moment from "moment";
export default function Form() {
  //@ts-ignore
  const { language } = React.useContext(LanguageContext);
  const location = useLocation();
  const [idx, setIdx] = useState<any>("");
  const [unitid, setUnitid] = useState<any>("");
  const navi = useNavigate();
  const { user } = useAuth();
  const liStyle = {
    padding: "10px",
    width: "100%",
    cursor: "pointer",
    borderBottom: "1px solid gray",
  };
  // State defines
  //=======================================================================
  function translate(kr: string, en: string) {
    return language === "KOR" ? kr : en;
  }
  //=======================================================================
  const [rawData, setRawData] = useState<any>({});
  const [isReadOnly, setIsReadOnly] = useState<boolean>(true);
  const [CPN, setCPN] = useState<any>("");
  const [CPNData, setCPNData] = useState<any>([]);
  const [isChanged, setIsChanged] = useState<boolean>(false);
  const [companyData, setCompanyData] = useState<any>([]);
  const [prodList, setProdList] = useState<any>([]);
  const [classList, setClassList] = useState<any>();

  const prodListVar = [
    prodList.map((item: any) => {
      return {
        name: item.prod_legal_nm,
        value: item.idx,
      };
    }),
  ];

  // Function defines
  //=======================================================================

  //=======================================================================
  function inputHandler(e: any) {
    const { name, value } = e.target;
    setRawData((pre: any) => ({ ...pre, [name]: value }));
  }
  function createNew() {
    if (CPN === "") {
      Swal.fire({
        title: `${translate(
          "회사/지점/대리점명	 선택해주세요.",
          "Please select a company/branch/agency name.",
        )}`,
      });
      return;
    }
    if (rawData.org_nm === "") {
      Swal.fire({
        title: `${translate(
          "회사/지점/대리점명	 선택해주세요.",
          "Please select a company/branch/agency name.",
        )}`,
      });
      return;
    }
    if (rawData.prod_legal_nm === "") {
      Swal.fire({
        title: `${translate(
          "단말기 종류를 선택해주세요.",
          "Please select a device type.",
        )}`,
      });
      return;
    }
    if (rawData.no_view === "") {
      Swal.fire({
        title: `${translate(
          "미관제 설정 시간을 선택해주세요.",
          "Please select a uncontrolled setting time.",
        )}`,
      });
      return;
    }
    if (!String(rawData.unit_sn ?? "").trim()) {
      Swal.fire({
        title: `${translate(
          "S/N 번호를 입력해주세요.",
          "Please enter the S/N number.",
        )}`,
      });
      return;
    }
    if (
      Number(rawData.prod_legal_nm) === 7 &&
      !String(rawData.uid ?? "").trim()
    ) {
      Swal.fire({
        title: `${translate(
          "단말기 UID를 입력해주세요.",
          "Please enter the device UID.",
        )}`,
      });
      return;
    }
    axios.post("/web/admin/terminal/edit", rawData).then((res: any) => {
      if (res.status === 200) {
        Swal.fire({
          title: `${translate("수정되었습니다", "Edit complete")}`,
        }).then((result) => {
          navi("/Adm/dev-table");
        });
      } else {
        Swal.fire({
          title: `${translate("수정에 실패하였습니다", "Edit failed")}`,
        });
      }
    });
  }
  function onChangeFilter(e: any) {
    setCPN(e.target.value);
    handleFilterChange(e);
  }
  function handleFilterChange(e: any) {
    const searchText = e.target.value;

    if (searchText === "") {
      setCPNData([]);
      return;
    }
    const filteredData = companyData.filter((item: any) => {
      return (
        (item.cmp_nm &&
          item.cmp_nm.toLowerCase().includes(searchText.toLowerCase())) ||
        (item.brc_nm &&
          item.brc_nm.toLowerCase().includes(searchText.toLowerCase())) ||
        (item.agt_nm &&
          item.agt_nm.toLowerCase().includes(searchText.toLowerCase()))
      );
    });

    setCPNData(filteredData);
  }
  function editCPN(e: any) {
    if (!isReadOnly) {
      setIsChanged(true);
    }
  }
  function clearinput() {
    setIsReadOnly(false);
    setCPN("");
    setCPNData([]);
  }
  // Data definition
  //=======================================================================
  const buttonData = [
    {
      labelKR: "목록",
      labelEN: "List",
      classN: "purple",
      clickFun: () => {
        window.history.back();
      },
      position: "left",
      icon: false,
      iconClass: "",
    },
    {
      labelKR: "삭제",
      labelEN: "Delete",
      classN: "white",
      icon: true,
      clickFun: () => {
        DeleteFun(
          `/web/admin/terminal/del`,
          {
            idx: idx,
            type: "ADM",
            admin_idx: user.idx,
            admin_id: user.id,
            unitid: rawData.unitid,
          },
          navi,
        );
      },
      position: " right",
    },
    {
      labelKR: "수정",
      labelEN: "Edit",
      classN: "purple",
      icon: true,
      clickFun: () => {
        createNew();
      },
      position: "",
    },
  ];
  // UseEffect defines
  //=======================================================================

  useEffect(() => {
    if (location.state !== null) {
      setIdx(location.state.idx);
      setUnitid(location.state.unitid);
    }
    axios.get(`/web/admin/prod/list?type=${user.type}`).then((res: any) => {
      setProdList(res.data);
    });
  }, [location, user]);

  useEffect(() => {
    if (idx !== "") {
      axios
        .get(
          `/web/admin/terminal/detail?idx=${idx}&unitid=${unitid}&type=${user.type}`,
        )
        .then((res: any) => {
          setRawData(res.data);
          setRawData((prev: any) => ({
            ...prev,
            type: user.type,
          }));
          setCPN(
            `${
              res.data.org_type === "C"
                ? "회사"
                : res.data.org_type === "B"
                  ? "지점"
                  : res.data.org_type === "A"
                    ? "대리점"
                    : ""
            } > ${res.data.org_nm}`,
          );
        });
    } else {
      setRawData({});
    }
  }, [idx, user.type, unitid]);
  useEffect(() => {
    function getCompanyData() {
      axios
        .get(`/web/admin/org/name?type=ADM`)
        .then((res: any) => {
          setCompanyData(res.data);
        })
        .catch((err: any) => {
          console.log(err);
        });
    }
    function getClassList() {
      axios
        .get(`/web/admin/terminal/category?type=ADM`)
        .then((res: any) => {
          setClassList(res.data);
        })
        .catch((err: any) => {
          console.log(err);
        });
    }

    getClassList();
    getCompanyData();
  }, [user]);
  useEffect(() => {
    if (rawData.kind !== "" || rawData.kind !== undefined) {
      classList?.map((item: any) => {
        if (item.idx === parseInt(rawData.kind)) {
          setRawData((prev: any) => ({
            ...prev,
            kind_nm: item.nm_kor,
          }));
        }
        return null;
      });
    }
  }, [rawData.kind, classList]);
  // Log defines
  //=======================================================================
  // console.log("rawData", rawData);
  // console.log(prodListVar);
  // console.log("prodList", prodList);
  // console.log("state", location.state);
  // console.log("idx", idx);
  // console.log("CompanyData", companyData);
  // console.log("user", user.type);
  // console.log("refId", refId.current?.value);
  return (
    <>
      <Page
        language={language}
        dataList={dataList}
        title={`${language === "KOR" ? "단말기 관리" : "Gadget management"}`}
        menu="/Adm/dev-table"
      >
        <table className="common-view-table">
          <colgroup>
            <col style={{ width: "19rem" }} />
            <col />
            <col style={{ width: "19rem" }} />
            <col />
          </colgroup>
          <tbody>
            <tr>
              <th className="required">
                {translate("회사/지점/대리점명", "Company/Branch/Agency name")}
              </th>
              <td
                colSpan={3}
                style={{
                  position: "relative",
                }}
              >
                <div className="flex">
                  <div className="custom-input wide">
                    <input
                      name="org_nm"
                      type="text"
                      placeholder={translate(
                        "회사/지점/대리점명을 입력해주세요",
                        "enter com/branch/agent name",
                      )}
                      onChange={onChangeFilter}
                      onFocus={(e) => editCPN(e)}
                      readOnly={isReadOnly}
                      value={CPN || ""}
                      autoComplete="off"
                    />
                  </div>
                  <button
                    type="button"
                    className="common-btn white sm"
                    onClick={() => clearinput()}
                  >
                    <span>{translate("초기화", "Reset")}</span>
                  </button>
                </div>
                {isChanged && CPNData.length > 0 ? (
                  <ul
                    className="search-list"
                    style={{
                      position: "absolute",
                      backgroundColor: "white",
                      zIndex: 100,
                      width: "80%",
                      marginTop: "5px",
                      maxHeight: "200px",
                      overflow: "scroll",
                      border: "1px solid #cccc",
                      overflowX: "hidden",
                    }}
                  >
                    {CPNData.map((item: any, index: any) => (
                      <li
                        style={liStyle}
                        key={index}
                        onClick={() => {
                          setRawData((prev: any) => ({
                            ...prev,
                            org_type: item.org_type,
                            btoc_yn: item.btoc_yn,
                          }));
                          setCPN(
                            `${
                              item.org_type === "C"
                                ? translate("[회사]", "[Company]")
                                : item.org_type === "B"
                                  ? translate("[지점]", "[Branch]")
                                  : item.org_type === "A"
                                    ? translate("[대리점]", "[Agent]")
                                    : ""
                            } ${item.cmp_nm}${
                              item.brc_nm === null ? "" : " > "
                            }${item.brc_nm === null ? "" : item.brc_nm}${
                              item.agt_nm === null ? "" : " > "
                            }${
                              item.agt_nm === null ? "" : item.agt_nm
                            } (회사코드 : ${item.org_cd})`,
                          );
                          setRawData((prev: any) => ({
                            ...prev,
                            org_idx: item.idx,
                            agt_idx: item.agt_idx,
                            brc_idx: item.brc_idx,
                            cmp_idx: item.cmp_idx,
                            u_type: item.org_type,
                            sso_yn: item.sso_yn === "Y" ? "Y" : "N",
                          }));
                          setIsChanged(false);
                          setIsReadOnly(true);
                        }}
                      >
                        {item.org_type === "C"
                          ? translate("[회사]", "[Company]")
                          : item.org_type === "B"
                            ? translate("[지점]", "[Branch]")
                            : item.org_type === "A"
                              ? translate("[대리점]", "[Agent]")
                              : ""}
                        {` ${item.cmp_nm}`}
                        {item.brc_nm === null ? "" : ` > ${item.brc_nm}`}
                        {item.agt_nm === null ? "" : ` > ${item.agt_nm}`}
                        {` (회사코드 : ${item.org_cd})`}
                      </li>
                    ))}
                  </ul>
                ) : (
                  ""
                )}
              </td>
            </tr>
            <tr>
              <th className="required">
                {translate("단말기 종류", "Device type")}
              </th>
              <td>
                <Select
                  name="prod_legal_nm"
                  changeFun={(e: any) => inputHandler(e)}
                  id=""
                  short="N"
                  options={prodListVar.length > 0 ? prodListVar[0] : []}
                  def={rawData.prod_legal_nm ? rawData.prod_legal_nm : ""}
                />
              </td>
              <th className="required">
                {translate("미관제 설정 시간", "Confirmation set time")}
              </th>
              <td>
                <Select
                  name="no_view"
                  changeFun={(e: any) => inputHandler(e)}
                  id="no_view"
                  short="N"
                  options={[
                    { name: "24", value: 24 },
                    { name: "48", value: 48 },
                    { name: "72", value: 72 },
                  ]}
                  def={rawData.no_view}
                />
              </td>
            </tr>
            <tr>
              <th>{translate("통신망 제조사", "Network")}</th>
              <td>
                <Select
                  name="make_cp"
                  changeFun={(e) => inputHandler(e)}
                  id="make_cp"
                  short="N"
                  options={[
                    { name: "KT", value: "KT" },
                    { name: "SKT", value: "SKT" },
                    { name: "LG", value: "LG" },
                  ]}
                  def={rawData.make_cp}
                />
              </td>
              <th>{translate("약정", "Contracts")}</th>
              <td>
                <Select
                  name="term"
                  changeFun={(e) => inputHandler(e)}
                  id="term"
                  short="N"
                  options={[
                    { name: "이벤트", value: "이벤트" },
                    { name: "무약정", value: "무약정" },
                    { name: "1년", value: "1년" },
                    { name: "2년", value: "2년" },
                    { name: "3년", value: "3년" },
                    { name: "5년", value: "5년" },
                  ]}
                  def={rawData.term}
                />
              </td>
            </tr>
            <tr>
              <th>{translate("아이콘 설정", "Icon Settings")}</th>
              <td colSpan={3}>
                <div className="custom-check-group">
                  <Radio
                    name={"icon_code"}
                    val={"IC01"}
                    title={translate("차량", "Car")}
                    change={(e) => inputHandler(e)}
                    check={rawData.icon_code === "IC01" ? true : false}
                  />
                  <Radio
                    name={"icon_code"}
                    val={"IC02"}
                    title={translate("오토바이", "Bike")}
                    change={(e) => inputHandler(e)}
                    check={rawData.icon_code === "IC02" ? true : false}
                  />
                  <Radio
                    name={"icon_code"}
                    val={"IC03"}
                    title={translate("사람", "Human")}
                    change={(e) => inputHandler(e)}
                    check={rawData.icon_code === "IC03" ? true : false}
                  />
                  <Radio
                    name={"icon_code"}
                    val={"IC04"}
                    title={translate("자전거", "Bicycle")}
                    change={(e) => inputHandler(e)}
                    check={rawData.icon_code === "IC04" ? true : false}
                  />
                  <Radio
                    name={"icon_code"}
                    val={"IC05"}
                    title={translate("트럭", "Track")}
                    change={(e) => inputHandler(e)}
                    check={rawData.icon_code === "IC05" ? true : false}
                  />
                  <Radio
                    name={"icon_code"}
                    val={"IC06"}
                    title={translate("폐기물차량", "Trash car")}
                    change={(e) => inputHandler(e)}
                    check={rawData.icon_code === "IC06" ? true : false}
                  />
                  <Radio
                    name={"icon_code"}
                    val={"IC07"}
                    title={translate("통학버스", "School bus")}
                    change={(e) => inputHandler(e)}
                    check={rawData.icon_code === "IC07" ? true : false}
                  />
                  <Radio
                    name={"icon_code"}
                    val={"IC08"}
                    title={translate("항공", "Plane")}
                    change={(e) => inputHandler(e)}
                    check={rawData.icon_code === "IC08" ? true : false}
                  />
                  <Radio
                    name={"icon_code"}
                    val={"IC09"}
                    title={translate("선박", "Ship")}
                    change={(e) => inputHandler(e)}
                    check={rawData.icon_code === "IC09" ? true : false}
                  />
                  <Radio
                    name={"icon_code"}
                    val={"IC10"}
                    title={translate("크레인", "Crane")}
                    change={(e) => inputHandler(e)}
                    check={rawData.icon_code === "IC10" ? true : false}
                  />
                  <Radio
                    name={"icon_code"}
                    val={"IC11"}
                    title={translate("반려동물", "Pet")}
                    change={(e) => inputHandler(e)}
                    check={rawData.icon_code === "IC11" ? true : false}
                  />
                </div>
              </td>
            </tr>
            <tr>
              <th>{translate("판매처", "Sales shop")}</th>
              <td>
                <div className="custom-input">
                  <input
                    name="buy"
                    type="text"
                    onChange={inputHandler}
                    value={rawData.buy === undefined ? "" : rawData.buy}
                  />
                </div>
              </td>
              <th>{translate("단말기 분류", "Terminal classification")}</th>
              <td>
                <Select
                  name="kind"
                  changeFun={(e) => inputHandler(e)}
                  id="kind"
                  short="N"
                  options={
                    classList !== undefined
                      ? classList.map((item: any) => {
                          return {
                            name: `${translate(item.nm_kor, item.nm_eng)}`,
                            value: item.idx,
                          };
                        })
                      : []
                  }
                  def={rawData.kind}
                />
              </td>
            </tr>
            <tr>
              <th>{translate("특이", "Unusual")}</th>
              <td>
                <Select
                  name="matter"
                  changeFun={(e) => inputHandler(e)}
                  id="matter"
                  short="N"
                  options={[
                    { name: "정상", value: "정상" },
                    { name: "차량고장", value: "차량고장" },
                    { name: "점검", value: "점검" },
                    { name: "미운행", value: "미운행" },
                  ]}
                  def={rawData.matter}
                />
              </td>
              <th>{translate("사용여부", "Use")}</th>
              <td>
                <div className="custom-check-group">
                  <Radio
                    name={"act_yn"}
                    val={"Y"}
                    title={translate("사용", "Use")}
                    change={(e) => inputHandler(e)}
                    check={rawData.act_yn === "Y" ? true : false}
                  />
                  <Radio
                    name={"act_yn"}
                    val={"N"}
                    title={translate("미사용", "Not use")}
                    change={(e) => inputHandler(e)}
                    check={rawData.act_yn === "N" ? true : false}
                  />
                </div>
              </td>
            </tr>
            <tr>
              <th>{translate("수정일", "Edit Day")}</th>
              <td>
                <div className="custom-input">
                  <input
                    name="editdate"
                    type="text"
                    onChange={inputHandler}
                    value={
                      rawData.editdate === undefined ||
                      rawData.editdate === null
                        ? ""
                        : moment
                            .utc(rawData.editdate)
                            .format("YYYY-MM-DD HH:mm:ss")
                    }
                    readOnly
                  />
                </div>
              </td>
              <th>{translate("등록자/일시", "Reg. Day")}</th>
              <td>
                <div className="custom-input">
                  <input
                    name="makedate"
                    type="text"
                    onChange={inputHandler}
                    value={
                      moment
                        .utc(rawData.makedate)
                        .format("YYYY-MM-DD HH:mm:ss") +
                      " / " +
                      rawData.make_uname
                    }
                    readOnly
                  />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div
          className="sub-page-header"
          style={{
            marginTop: "2rem",
          }}
        >
          <div className="header-title">단말기 정보</div>
        </div>
        <table className="common-view-table">
          <colgroup>
            <col style={{ width: "13rem" }} />
            <col />
            <col style={{ width: "13rem" }} />
            <col />
            <col style={{ width: "13rem" }} />
            <col />
            <col style={{ width: "13rem" }} />
            <col />
          </colgroup>
          <tbody>
            <tr>
              <th className="required">
                {translate("단말기 번호", "Terminal number")}
              </th>
              <td>
                <div className="custom-input">
                  <input
                    name="unitid"
                    type="text"
                    onChange={inputHandler}
                    value={rawData.unitid === undefined ? "" : rawData.unitid}
                    readOnly
                  />
                </div>
              </td>
              <th className="required">{translate("S/N 번호", "SN.Number")}</th>
              <td>
                <div className="custom-input">
                  <input
                    name="unit_sn"
                    type="text"
                    onChange={inputHandler}
                    value={rawData.unit_sn === undefined ? "" : rawData.unit_sn}
                  />
                </div>
              </td>
              <th className="required">
                {translate("단말기 명칭", "Device Name")}
              </th>
              <td>
                <div className="custom-input">
                  <input
                    name="unit_nm"
                    type="text"
                    onChange={inputHandler}
                    value={rawData.unit_nm === undefined ? "" : rawData.unit_nm}
                  />
                </div>
              </td>
              <th className="required">
                {translate("단말기 UID", "Device UID")}
              </th>
              <td>
                <div className="custom-input">
                  <input
                    name="uid"
                    type="text"
                    disabled={Number(rawData.prod_legal_nm) !== 7}
                    onChange={inputHandler}
                    value={rawData.uid === undefined ? "" : rawData.uid}
                  />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <CommonControl buttonData={buttonData} language={language} />
      </Page>
    </>
  );
}
